import { Link } from 'react-router-dom';
import InfoPage from './InfoPage';

export default function AboutPage() {
  return (
    <InfoPage title="Your AI Study Tutor" intro="LAVYN helps students ask questions, work through schoolwork, and review what they are learning. Start with a question or a photo, then choose how you want it explained.">
      <section aria-labelledby="about-workflow">
        <h2 id="about-workflow">A question. An explanation. A next step.</h2>
        <p>Use Snap &amp; Solve to take or upload a photo of a schoolwork question. You can also type a question into Ask LAVYN on Home, with or without a photo. Choose a learning mode and a text explanation or an AI-narrated teaching video.</p>
        <p>Tutor is a place to ask follow-up questions and explore ideas in conversation. Narrated video lessons combine an AI explanation with spoken teaching so you can listen as you learn.</p>
      </section>
      <section aria-labelledby="about-tools">
        <h2 id="about-tools">Keep learning after the answer</h2>
        <div className="public-tools">
          <div><h3><Link to="/?tool=Practice">Practice</Link></h3><p>Work through a topic one question at a time.</p></div>
          <div><h3><Link to="/?tool=Study%20Cards">Study Cards</Link></h3><p>Review important ideas with cards you can revisit.</p></div>
          <div><h3><Link to="/?tool=Quick%20Learn">Quick Learn</Link></h3><p>Get a shorter explanation of a topic or source.</p></div>
          <div><h3><Link to="/?tool=Smart%20Calculator">Smart Calculator</Link></h3><p>Enter an expression to explore results, steps, and graphs.</p></div>
        </div>
      </section>
      <section aria-labelledby="about-start">
        <h2 id="about-start">Get started</h2>
        <ol>
          <li><Link to="/">Open Home</Link> to type your question or attach schoolwork. Use Snap &amp; Solve for a photo.</li>
          <li>Choose your learning mode and text or video output, then send your question.</li>
          <li><Link to="/ai-assistant">Open Tutor</Link> for a conversation, or choose a study tool above to review.</li>
          <li><Link to="/auth/signup">Create an account</Link> or <Link to="/auth/login">sign in</Link> to check your account’s access and allowance.</li>
        </ol>
      </section>
      <section aria-labelledby="about-plans">
        <h2 id="about-plans">Free and Premium — offer preview</h2>
        <div className="public-plans">
          <div className="public-notice"><h3>Free</h3><p>4 AI teaching videos per calendar month.</p></div>
          <div className="public-notice"><h3>Premium</h3><p>12 AI teaching videos per billing month. Displayed offer price: 89.99 monthly.</p></div>
        </div>
        <p className="mt-4">These plan limits do not show how many generations you have remaining. Your current allowance and access are determined by your verified account. The Premium price is an offer preview. Checkout is not available; this page does not sell or activate a subscription.</p>
        <p><Link to="/profile/premium">View the Premium preview</Link> or <Link to="/profile">check your profile</Link>.</p>
      </section>
      <section aria-labelledby="about-ai">
        <h2 id="about-ai">Study with care</h2>
        <p>AI explanations can be wrong. Check important answers against your class notes, textbook, or teacher, and use explanations to understand the work rather than treating them as guaranteed answers.</p>
      </section>
    </InfoPage>
  );
}
